module.exports = {"title":"Tickets Assignment","both":"Both","boxOfficeOnly":"Box office only","noOne":"No one","saveClose":"Save and Close"}


//////////////////
// WEBPACK FOOTER
// ./src/components/CreateEvent/DatesModal/locales/fr.json
// module id = 1663
// module chunks = 0